import React, { Fragment } from 'react';
import { Transition, Dialog } from '@headlessui/react';
import { isXamarin } from '../../services/mobileService';
import { useContext } from 'react';
import { DiseaseGroupContext } from '../../contexts/diseaseGroupContext';

export const ModalDialog = ({ show, onClose, children }) => {
  const heightClass = isXamarin() ? 'h-screen' : 'h-full';

	const { theme } = useContext(DiseaseGroupContext);

  return (
    <Transition
      appear
      show={show}
      as={Fragment}
    >
      <Dialog
        as="div"
        className={`absolute z-40 top-0 left-0 w-full ${heightClass} flex px-4 p-safeAreaTop p-safeAreaBottom items-center justify-center`}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className={`absolute top-0 left-0 w-full h-full ${theme.primary().bg()} bg-opacity-70 flex p-4 items-center justify-center`}
        >
          <Dialog.Overlay className="fixed inset-0" />          
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-75"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          {children}
        </Transition.Child>
      </Dialog>
    </Transition> 
  )
}
